import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StringMap } from '@angular/compiler/src/compiler_facade_interface';



@NgModule({
  declarations: [],
  imports: [
    CommonModule
  ]
})
export class HojaModule { 
  version:string;
  codigo :string ="0";
  codigoInterno :string ="0";
  producto :string ;
  id_pais:number;
  fm :number =0;
  am1 :number =0;
  amval1 :number =0;
  pm1 :number =0;
  valpm1 :number =0;
  dev1 :number =0;
  color1:string;
  am2 :number =0;
  valam2 :number =0;
  pm2 :number =0;
  valpm2 :number =0;
  dev2 :number =0;
  color2:string;
  am3 :number =0;
  amval3 :number =0;
  pm3 :number =0;
  valpm3 :number =0;
  dev3 :number =0;
  color3:string;
  am4 :number =0;
  amval4 :number =0;
  pm4 :number =0;
  valpm4 :number =0;
  dev4 :number =0;
  color4:string;
  am5 :number =0;
  amval5 :number =0;
  pm5 :number =0;
  valpm5 :number =0;
  dev5 :number =0;
  color5:string;
  am6 :number =0;
  amval6 :number =0;
  pm6 :number =0;
  valpm6 :number =0;
  dev6 :number =0;
  color6:string;
  am7 :number =0;
  amval7 :number =0;
  pm7 :number =0;
  valpm7 :number =0;
  dev7:number =0;
  color7:string;
  periodo:number =0;


  am8 :number =0;
  amval8 :number =0;
  pm8 :number =0;
  valpm8 :number =0;
  dev8:number =0;
  color8:string;
  
   semana:number =0;
  anio:number =0;
  fecha:string;
  fechafinal:string;
  id_producion:number =0;
  id_local :number =0;
  meta :number =0;
  categoria:string;
  sugerido :number =0;
  local :number =0;
  devolucion :number =0;
  porcentaje :number =0;
  color:string;
  colorPorcentaje:string;
  numeral:number;

  devolucionAnterior :number =0;
}
